/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_sea-waves': {
    width: 16,
    height: 16,
    viewBox: '0 0 35 6.102',
    data: '<path pid="0" d="M29.915 2.279a4.767 4.767 0 01-7.33 0 6.812 6.812 0 00-10.17 0 4.767 4.767 0 01-7.33 0A6.859 6.859 0 000-.001v2.1a4.847 4.847 0 013.665 1.718 6.812 6.812 0 0010.17 0 4.767 4.767 0 017.33 0 6.812 6.812 0 0010.17 0A4.847 4.847 0 0135 2.099v-2.1a6.859 6.859 0 00-5.085 2.28z" _fill="#959ba6"/>'
  }
})
